import { QueueNotification } from 'components/QueueNotification/QueueNotification';
import { SnackbarProvider } from 'notistack';
import './snackbar.css';

export const AppProvider = ({ children }) => (
  <SnackbarProvider
    anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
    maxSnack={5}
    Components={{
      info: QueueNotification,
      error: QueueNotification,
      success: QueueNotification,
      default: QueueNotification,
      warning: QueueNotification,
    }}>
    <div>{children}</div>
  </SnackbarProvider>
);
